/**
 * MapEmptyState (UI-SPEC W6) — replaces the map canvas when zero assets
 * are imported. Card with import-CTA pointing at /assets/import.
 *
 * Map does NOT mount in this state (saves WebGL context + bandwidth).
 */
import { Map as MapIcon } from "lucide-react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

export function MapEmptyState() {
  return (
    <div
      className="min-h-screen bg-surface flex items-center justify-center"
      data-testid="map-empty"
    >
      <div className="bg-surface-raised rounded-lg shadow-sm border border-divider p-12 max-w-[480px] text-center">
        <MapIcon
          size={48}
          className="text-text-secondary mx-auto mbe-4"
          aria-hidden="true"
        />
        <h2 className="text-2xl font-semibold text-on-surface mbe-2">
          <FormattedMessage id="LABEL_NO_ASSETS_YET_HEADING" />
        </h2>
        <p className="text-base text-text-secondary mbe-6">
          <FormattedMessage id="LABEL_NO_ASSETS_YET_BODY" />
        </p>
        <Link
          to="/assets/import"
          data-testid="map-empty-import-cta"
          className="inline-flex items-center justify-center h-11 ps-4 pe-4 rounded-md font-semibold bg-primary hover:bg-primary-tint text-on-primary focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 transition-colors duration-200"
        >
          <FormattedMessage id="LABEL_IMPORT_ASSETS" />
        </Link>
      </div>
    </div>
  );
}
